import { useCallback, useEffect, useState } from "react";
import { doctorLogin, doctorMe, DOCTOR_SESSION_EXPIRED_EVENT } from "../lib/api";
import { goToSessionExpired } from "../pages/StatusPages";

const TOKEN_KEY = "lc_doctor_token_v1";
const ENDED = "Your session has ended (12-hour limit) — please sign in again.";

export function useDoctorAuth() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const clear = useCallback((msg = "") => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setProfile(null);
    setError(msg);
    if (msg === ENDED) goToSessionExpired();
  }, []);

  const refresh = useCallback(async (t) => {
    const useTok = t || token;
    if (!useTok) {
      setProfile(null);
      setLoading(false);
      return;
    }
    try {
      setProfile(await doctorMe(useTok));
    } catch (err) {
      if (err?.response?.status === 401) clear(ENDED);
    } finally {
      setLoading(false);
    }
  }, [token, clear]);

  useEffect(() => {
    refresh();
    const onExpired = () => clear(ENDED);
    window.addEventListener(DOCTOR_SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(DOCTOR_SESSION_EXPIRED_EVENT, onExpired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const r = await doctorLogin(email, password);
      localStorage.setItem(TOKEN_KEY, r.token);
      setToken(r.token);
      setProfile(r.doctor);
      return true;
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      setError(typeof msg === "string" ? msg : "Login failed");
      return false;
    }
  };

  const logout = () => clear();

  return { token, profile, loading, error, login, logout, refresh };
}
